<template>
  <section class="checks-container">
    <checks-fill
      v-if="selectedItem"
      :item="selectedItem"
      @increment="incrementPayments"
      @decrement="decrementPayments"
      @updateFirstPaymentDate="updateFirstPaymentDate"
      @saveCheck="saveCheck"
      @removeCheck="removeCheck"
    />

    <footer>
      <Button
        :disabled="!isAnyCheckCaptured"
        @click="isConfirmModal = true"
        class="capture-button  p-button-success p-button-rounded"
      >
        {{ __('Deposit confirmation') }}
        <i class="pi pi-arrow-left "></i>
      </Button>
    </footer>
    <i-override-dialog
      class="confirm-modal"
      :modal="true"
      :dismissableMask="true"
      :title="__('Are you sure you want to confirm the deposit?')"
      v-model:visible="isConfirmModal"
    >
      <Button class="plain-btn" @click="isConfirmModal = false">
        {{ __('Void') }}
      </Button>
      <Button @click="hanldeSubmitChecksGroup" class=" p-button-success ">
        {{ __('Yes') }}
      </Button>
    </i-override-dialog>
  </section>
</template>

<script>
import { checksService } from '@/services/checks.service.js'
import ChecksFill from '@/components/checks/checks-fill.vue'
// import { formatDate } from '@/services/apointUtil'
import { __ } from '@/plugins/i18n/index'
import Button from 'primevue/button'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      batchId: null,
      checksData: [],
      splitOptions: Array.from({ length: 12 }, (_, i) => ({
        label: `${i + 1}`,
        value: i + 1,
      })),
      isConfirmModal: false,
      showChecksFill: false,
      selectedItem: null,
    }
  },
  components: {
    ChecksFill,
    Button,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // Check if the user came from a specific route
      console.log('🚀 ~ beforeRouteEnter ~ from:', from)
      const isFromCheckCapture = from.name === 'CheckCapture'
      if (isFromCheckCapture) {
        // Do something
        vm.checkScannedCheckId(from.query?.checkGuid)
      }
      // Alternatively, you can check the path
      // vm.cameFromSpecificRoute = from.path === '/specific-path';
    })
  },
  async created() {
    if (this.checksGroupId) {
      let check = this.$store.getters.getChecksById(+this.checksGroupId)
      if (check) {
        this.selectedItem = JSON.parse(JSON.stringify(check))
      } else {
        this.$router.push(`/checks`)
      }
    } else {
      this.$router.push(`/checks`)
    }
  },
  methods: {
    checkScannedCheckId(checkGuid) {
      const check = this.selectedItem.checks.find(
        (c) => c.CheckGuid === checkGuid
      )
      if (check && !check.chex_checkID) {
        this.removeCheck(check, false)
      }
      return check.CheckGuid
    },

    addChecks(item) {
      this.selectedItem = item
      this.showChecksFill = true
    },
    incrementPayments() {
      this.selectedItem.NumbersOfPayments++
      this.splitToPayments(this.selectedItem)
    },
    decrementPayments() {
      if (this.selectedItem.NumbersOfPayments > 1) {
        this.selectedItem.NumbersOfPayments--
        this.splitToPayments(this.selectedItem)
      }
    },
    updateCheckInStore(check, index) {
      this.selectedItem.checks[index] = check
      if (check.CheckGuid) {
        this.saveCheckAtDb(check)
      }
      this.$store.dispatch('saveChecks', { checks: this.selectedItem })
    },
    async hanldeSubmitChecksGroup() {
      if (!this.isAnyCheckCaptured) {
        return
      }
      const checksGroup = {
        ChecksHeaderGuid: this.selectedItem.ChecksHeaderGuid,
        WorkerGuid: this.workerGUID,
        // ContactGuid: this.contactGuid, key for tennat ap
      }
      try {
        await this.$store.dispatch({ type: 'submitChecksGroup', checksGroup })
        this.$toast.add({
          severity: 'success',
          summary: __('Deposit confirmation'),
          detail: __('Deposit confirmation was successful'),
          life: 2000,
        })
        if (this.checksGroups.length) {
          ~this.$router.push(`/checks`)
        } else {
          this.$router.push(`/`)
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: __('Error in deposit confirmation'),
          detail: __('Failed, try again later'),
          life: 2000,
        })
      }
    },
    async removeCheck(check, isShowCapture) {
      try {
        //create
        const checkCopy = { ...check }
        // checkCopy.chex_checkID = null
        // checkCopy.TransactionNumber = null
        // checkCopy.apiResponse = null

        const index = this.selectedItem.checks.findIndex(
          (c) => c.CheckGuid === check.CheckGuid
        )
        //remove thje check from lcoal state
        this.selectedItem.checks.splice(index, 1)
        await checksService.deleteCheck(checkCopy)

        //sending checkCopy meanwhile the check is not updated
        // this.selectedItem.checks[index] = res
        // this.selectedItem.checks[index] = checkCopy
        this.$store.dispatch('saveChecks', { checks: this.selectedItem })

        if (isShowCapture) {
          this.$router.push({
            name: 'CheckCapture',
            query: { captureUrl: res.scanUrl, checkGuid: res.CheckGuid },
          })
        }
      } catch (error) {
        console.error('Error removing check:', error)
      }
    },
    async saveCheckAtDb(check) {
      const adjustedDate = new Date(check.DepositDate)
      // adjustedDate.setDate(adjustedDate.getDate() + 1)

      check.DepositDate = adjustedDate.toISOString().split('T')[0]
      const res = await checksService.addOrUpdateCheck({
        CheckGuid: check.CheckGuid, // Ensure CheckGuid is correctly set for each check
        checksHeaderID: check.checksHeaderID || this.selectedItem.ID,
        Amount: check.Amount,
        TransactionNumber: check.TransactionNumber,
        apiResponse: check.apiResponse,
        CheckStatus: check.CheckStatus,
        DepositDate: check.DepositDate,
        ApprovedByUserId: check.ApprovedByUserId,
        ApprovalDate: check.ApprovalDate
          ? new Date(check.ApprovalDate).toISOString().slice(0, 10)
          : null,
        SentToDeposit: check.SentToDeposit,
        LastStatusChange: check.LastStatusChange
          ? new Date(check.LastStatusChange).toISOString().slice(0, 10)
          : null,
        LastStatusChangeByUserID: check.LastStatusChangeByUserID,
        redirect: location.origin + '/ccTranResult.html',
        scanUrl : check.scanUrl,
      })
      console.log('🚀 ~ saveCheckAtDb ~ res:', res)
      return res
    },
    async saveCheck(check, index) {
      try {
        // Save the check to the database and update the check
        // date array with the new check
        const adjustedDate = new Date(check.DepositDate)
        // adjustedDate.setDate(adjustedDate.getDate() + 1)

        check.DepositDate = adjustedDate.toISOString().split('T')[0]
        const res = await checksService.addOrUpdateCheck({
          CheckGuid: check.CheckGuid, // Ensure CheckGuid is correctly set for each check
          checksHeaderID: check.checksHeaderID || this.selectedItem.ID,
          Amount: check.Amount,
          TransactionNumber: check.TransactionNumber,
          apiResponse: check.apiResponse,
          CheckStatus: check.CheckStatus,
          DepositDate: check.DepositDate,
          ApprovedByUserId: check.ApprovedByUserId,
          ApprovalDate: check.ApprovalDate
            ? new Date(check.ApprovalDate).toISOString().slice(0, 10)
            : null,
          SentToDeposit: check.SentToDeposit,
          LastStatusChange: check.LastStatusChange
            ? new Date(check.LastStatusChange).toISOString().slice(0, 10)
            : null,
          LastStatusChangeByUserID: check.LastStatusChangeByUserID,
          redirect: location.origin + '/ccTranResult.html',
          scanUrl : check.scanUrl,
        })
        console.log('🚀 ~ saveCheck ~ res:', res)
        this.selectedItem.checks[index] = res
        this.$store.dispatch('saveChecks', { checks: this.selectedItem })

        this.$router.push({
          name: 'CheckCapture',
          query: {
            captureUrl: res.scanUrl,
            checkGuid: res.CheckGuid,
            checksGroupId: this.checksGroupId,
          },
        })
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: __('Error'),
          detail: __('Something went wrong'),
          life: 3000,
          closable: true,
        })
      }
        console.log('🚀 ~ saveCheck ~ adjustedDate:', adjustedDate)
        console.log('🚀 ~ saveCheck ~ adjustedDate:', adjustedDate)
        console.log('🚀 ~ saveCheck ~ adjustedDate:', adjustedDate)
        console.log('🚀 ~ saveCheck ~ adjustedDate:', adjustedDate)
    },
    async finishScan(check) {
      const updatedCheck = await checksService.finishScan({
        ...check,
      })
      this.$store.dispatch('updateCheck', { check: updatedCheck })
    },
    getSplitOptions(maxPolicy) {
      return Array.from({ length: maxPolicy }, (_, i) => i + 1)
    },
    getDaysInMonth() {
      return Array.from({ length: 28 }, (_, i) => i + 1)
    },
    formatMonthYear(date) {
      try {
        return `/${('0' + (date.getMonth() + 1)).slice(
          -2
        )}/${date.getFullYear()}`
      } catch (error) {
        console.log(error, date)
      }
    },
    splitToPayments(checksGroup) {
      // Split the payment to the number of payments
      //when we split the amount the all amounts need to by abs numbers just the first one can be with cents

      const totalAmount = Math.abs(checksGroup.Amount)
      const baseAmount = Math.floor(totalAmount / checksGroup.NumbersOfPayments)
      const firstAmount =
        totalAmount - baseAmount * (checksGroup.NumbersOfPayments - 1)
      const firstCheckDay1 = checksGroup.checks[0].DepositDate
      const newChecks = []

      // Ensure firstCheckDay is a Date object
      let firstCheckDay = new Date(firstCheckDay1)

      //run for all check and if there is a check with checkGuid we need to remove it
      checksGroup.checks.forEach(async (check) => {
        if (check.CheckGuid) {
          await checksService.deleteCheck(check)
        }
      })

      for (let i = 0; i < checksGroup.NumbersOfPayments; i++) {
        // Create a new Date object for each iteration
        let checkDate = new Date(firstCheckDay)

        // Adjust the month
        checkDate.setMonth(firstCheckDay.getMonth() + i)

        newChecks.push(
          checksService.getEmptyCheck(
            checksGroup.ID,
            i === 0 ? firstAmount : baseAmount,
            checkDate // Use the adjusted date
          )
        )
      }

      checksGroup.checks = newChecks
      this.$store.dispatch('saveChecks', { checks: checksGroup })
    },
    updateFirstPaymentDate(date) {
      this.selectedItem.checks[0].DepositDate = new Date(date)

      this.selectedItem.checks.forEach(async (check, index) => {
        if (index === 0) {
          check.DepositDate = new Date(date)
        } else {
          let newDate = new Date(date)
          newDate.setMonth(newDate.getMonth() + index)
          check.DepositDate = newDate
        }

        if (check.CheckGuid) {
          try {
            // Adjust the date to prevent the off-by-one-day issue
            const adjustedDate = new Date(check.DepositDate)
            // adjustedDate.setDate(adjustedDate.getDate() + 1)

            // Transform the adjusted deposit date to ISO format for the API
            const checkToUpdate = {
              ...check,
              DepositDate: adjustedDate.toISOString().split('T')[0],
            }
            const updatedCheck = await checksService.addOrUpdateCheck(
              checkToUpdate
            )
            console.log('🚀 ~ this.selectedItem.checks.forEach ~ updatedCheck:', updatedCheck)

            // Ensure the local state reflects the correct date
            updatedCheck.DepositDate = new Date(updatedCheck.DepositDate)
            this.$store.dispatch('updateCheck', { check: updatedCheck })
          } catch (error) {
            console.error('Error updating check:', error)
            // Handle the error appropriately
          }
        }
      })

      this.$store.dispatch('saveChecks', { checks: this.selectedItem })
    },
    updateDepositDate(row) {
      const newDate = new Date(row.DepositDate)
      newDate.setDate(row.day)
      row.DepositDate = newDate
    },
    captureCheck(row) {
      // Logic to capture check image
      console.log('Capture check for:', row)
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  computed: {
    ...mapState({
      contactGuid: (state) => state.api.contactGuid,
      workerGUID: (state) => state.api.workerGUID,
    }),
    checksGroups() {
      return this.$store.getters.checks
    },
    isAnyCheckCaptured() {
      if (!this.selectedItem) return false
      return this.selectedItem.checks.some((check) => check.CheckGuid)
    },
    checksGroupId() {
      return this.$route.params.checksGroupId
    },
  },
}
</script>
